'use strict';

var getAbsoluteUrl = function(url) {
	var a = document.createElement('a');
	getAbsoluteUrl = function(url) {
		a.href = url;
		return a.href;
	}
	return getAbsoluteUrl(url);  
};

module.exports = getAbsoluteUrl; 